import React from 'react';
import {
  Box,
  CircularProgress,
  Backdrop,
  Grid,
  Snackbar,
} from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';

export interface LoadingWrapperProps {
  loading: boolean;
  hasConfig: boolean;
  submitting: boolean;
  error: boolean | string;
  submitted: boolean;
  children: React.ReactNode;
}

const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
  },
}));

export const LoadingWrapper: React.FC<LoadingWrapperProps> = ({
  children,
  loading,
  error = false,
  hasConfig,
  submitting = false,
  submitted,
}) => {
  const classes = useStyles();
  if (loading) {
    return (
      <Box>
        <CircularProgress />
      </Box>
    );
  } else if (!hasConfig) {
    return <p>This form type is not available for this location</p>;
  } else {
    return (
      <>
        {children}
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={submitted}
          message={<Box>Form submitted successfully</Box>}
        ></Snackbar>

        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={!!error}
          message={
            <Box>
              {typeof error === 'string'
                ? `Error: ${error}`
                : 'Error submitting form. Please try again.'}
            </Box>
          }
        ></Snackbar>

        <Backdrop
          open={submitting}
          className={classes.backdrop}
          transitionDuration={{ exit: 300 }}
        >
          <Grid
            container
            justify="center"
            alignItems="center"
            direction="column"
          >
            <CircularProgress color="inherit" />
            <p>Submitting</p>
          </Grid>
        </Backdrop>
      </>
    );
  }
};

export default LoadingWrapper;
